import { render, staticRenderFns } from "./DiagramUpdate.vue?vue&type=template&id=6d4d23d6&scoped=true&"
import script from "./DiagramUpdate.vue?vue&type=script&lang=js&"
export * from "./DiagramUpdate.vue?vue&type=script&lang=js&"
import style0 from "./DiagramUpdate.vue?vue&type=style&index=0&id=6d4d23d6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d4d23d6",
  null
  
)

export default component.exports